/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

import { ROUTE_PREFIX } from '../../../constants/router';
import s from '../login/LoginForm.module.scss';
import render from '../../ReduxForm/renderField';
import getAssetLink from '../../../util/getAssetLink';

const validate = () => {
  const errors = {};
  return errors;
};

interface RegistrationType {
  username: string;
  password: string;
  confirmPassword: string;
}

interface RegistrationFormProps {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: any) => void;
  onCancel: () => void;
  errors?: Array<string>;
  withHeader?: boolean;
  withLoginLink?: boolean;
  withRegisterButton?: boolean;
}

class RegistrationForm extends React.Component<
  InjectedFormProps<RegistrationType, RegistrationFormProps> &
    RegistrationFormProps
> {
  // eslint-disable-next-line react/state-in-constructor
  state: any;

  static defaultProps = {
    errors: [],
    withHeader: true,
    withLoginLink: true,
    withRegisterButton: true,
  };

  constructor(props: any) {
    super(props);

    this.state = {
      dataProtectionChecked: false,
    };
  }

  render() {
    const {
      handleSubmit,
      onCancel,
      errors,
      withHeader,
      withLoginLink,
      withRegisterButton,
    } = this.props;
    const { dataProtectionChecked } = this.state;
    const dataProtectionCheckText = (
      <span className={s.span} style={{ margin: '0' }}>
        {' '}
        Ich stimme der Speicherung meines Passworts und meiner Abfrageergebnisse
        auf dem Server des Websitebetreibers zum Zweck der Wartung meines
        Accounts zu. Nähere Informationen zu meinen Datenschutzrechten und zu
        den Pflichten des Websitebetreibers finde ich{' '}
        <a
          href={`${ROUTE_PREFIX}/datenschutz`}
          target="_blank"
          rel="noopener noreferrer"
        >
          hier
        </a>
        .
      </span>
    );
    return (
      <div className={s.loginForm}>
        {withHeader && (
          <div className={s.loginHeader}>
            <h1>REGISTRIEREN</h1>
            <button className={s.cancelButton} type="button" onClick={onCancel}>
              <img src={getAssetLink('cross_thin.png')} alt="abbrechen" />
            </button>
          </div>
        )}
        <form className="default-form" onSubmit={handleSubmit}>
          <fieldset className={s.fieldset}>
            <label htmlFor="username">Benutzername</label>
            <Field
              id="username"
              name="username"
              type="text"
              placeholder=""
              component={render.renderInput}
            />
            <label htmlFor="password">Passwort</label>
            <Field
              id="password"
              name="password"
              type="password"
              placeholder=""
              component={render.renderInput}
            />
            <label htmlFor="confirmPassword">Passwort wiederholen</label>
            <Field
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder=""
              component={render.renderInput}
            />
            <div className={s.checkBoxBox}>
              <Field
                type="checkbox"
                id="dataProtectionCheck"
                name="dataProtectionCheck"
                component={render.renderCheckbox}
                style={{
                  minHeight: '20px',
                  paddingTop: '3px',
                }}
                checked={this.state.dataProtectionChecked}
                onChange={() =>
                  // eslint-disable-next-line prettier/prettier
                  this.setState({ dataProtectionChecked: !dataProtectionChecked })}
                label={dataProtectionCheckText}
              />
            </div>
            {errors != null && errors.length === 0 ? null : (
              <ul style={{ padding: 0, margin: 0, listStyleType: 'none' }}>
                {errors != null &&
                  errors.map((err) => (
                    <li key={err} className="validationError">
                      {err}
                    </li>
                  ))}
              </ul>
            )}
            {withRegisterButton && (
              <button
                type="submit"
                className={`wideButton ${s.loginButton}`}
                disabled={!this.state.dataProtectionChecked}
              >
                REGISTRIEREN
              </button>
            )}
          </fieldset>
          {withLoginLink && (
            <div className={s.links}>
              <Link to={`${ROUTE_PREFIX}/login`} className="link">
                ANMELDEN
              </Link>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default reduxForm<RegistrationType, RegistrationFormProps>({
  form: 'registration',
  validate,
  pure: false,
})(RegistrationForm);
